import React from 'react';
import { Link } from 'react-router-dom';
import './Legal.css';

export default function AGB() {
  return (
    <div className="legal-root">
      <div className="legal-bg-grid" />
      <div className="legal-glow" />

      <header className="legal-header">
        <Link to="/" className="legal-logo">
          <img src="/logo.png" alt="CVFlow" className="legal-logo__dot" />
        </Link>
      </header>

      <main className="legal-main">
        <div className="legal-eyebrow">Rechtliche Informationen</div>
        <h1 className="legal-title">Allgemeine Geschäftsbedingungen</h1>
        <div className="legal-divider" />

        <div className="legal-card">

          {/* §1 */}
          <section className="legal-section">
            <h2 className="legal-section__title">1. Vertragsgegenstand, Anbieteridentität und Änderungen der AGB</h2>
            <div className="legal-block">
              <p className="legal-prose">
                <strong>1.1</strong> Diese Allgemeinen Geschäftsbedingungen (AGB) gelten für die Nutzung der
                Software-as-a-Service-Lösung „CVFlow", betrieben durch die Ahmet Furkan Yazgin &amp;
                Mehmet Yüksel GbR, Kaltenweide 182, 25335 Elmshorn (im Folgenden „Anbieter").
              </p>
              <p className="legal-prose">
                <strong>1.2</strong> Bei kostenpflichtigen Paketen kommt der Vertrag zustande, sobald der Nutzer
                den Zahlungsprozess erfolgreich abschließt. Bei der kostenfreien Nutzung (Free-Tier) kommt der
                Vertrag mit der Registrierung und Bestätigung dieser AGB zustande. Die Bereitstellung des
                Accounts gilt in beiden Fällen als Auftragsbestätigung durch den Anbieter.
              </p>
              <p className="legal-prose">
                <strong>1.3</strong> Der Anbieter behält sich vor, diese AGB jederzeit zu ändern. Wesentliche
                Änderungen werden dem Nutzer rechtzeitig per E-Mail mitgeteilt. Widerspricht der Nutzer nicht
                innerhalb von 14 Tagen nach Zugang der Mitteilung, gelten die geänderten AGB als akzeptiert.
                Auf diese Folge wird der Anbieter in der Mitteilung gesondert hinweisen.
              </p>
            </div>
          </section>

          {/* §2 */}
          <section className="legal-section">
            <h2 className="legal-section__title">2. Leistungsbeschreibung, Support und Leistungsänderung</h2>
            <div className="legal-block">
              <p className="legal-prose">
                <strong>2.1</strong> Der Anbieter stellt eine Software-as-a-Service-Lösung zur Verfügung, die
                durch den Einsatz von Künstlicher Intelligenz (KI) Bewerbungsunterlagen analysiert, generiert
                und verwaltet. Die Plattform ist als Web-Applikation sowie als mobile App für iOS und Android
                verfügbar. Zu den Funktionen gehören unter anderem KI-gestützte Dokumentengenerierung,
                Stellenanzeigen-Import, Kalenderintegration (Google Calendar, Microsoft Calendar) sowie die
                Verwaltung von Bewerbungsprofilen und -unterlagen.
              </p>
              <p className="legal-prose">
                <strong>2.2</strong> Der Anbieter schuldet lediglich die Zurverfügungstellung der Software. Ein
                Erfolg im Bewerbungsverfahren oder die Vermittlung eines Arbeitsplatzes ist ausdrücklich nicht
                Teil der vertraglichen Leistung.
              </p>
              <p className="legal-prose">
                <strong>2.3</strong> Der Anbieter erbringt Supportleistungen ausschließlich zur Behebung
                technischer Störungen der Plattform. Ein Anspruch auf inhaltlichen Support, individuelle
                Anpassungen von Dokumenten oder ein Bewerbungscoaching besteht nicht.
              </p>
              <p className="legal-prose">
                <strong>2.4</strong> Der Anbieter ist berechtigt, seine Leistungen zu erweitern, dem technischen
                Fortschritt anzupassen und/oder Verbesserungen vorzunehmen. Der Anbieter ist zudem berechtigt,
                bisher kostenfrei zur Verfügung gestellte Zusatzfunktionen einzustellen oder zukünftig nur noch
                gegen Entgelt anzubieten.
              </p>
            </div>
          </section>

          {/* §3 */}
          <section className="legal-section">
            <h2 className="legal-section__title">3. Nutzungsrechte, Account-Sicherheit und Sperrung</h2>
            <div className="legal-block">
              <p className="legal-prose">
                <strong>3.1</strong> Der Anbieter räumt dem Nutzer ein einfaches, nicht übertragbares Recht ein,
                die Software für die Dauer des Vertragsverhältnisses für eigene, persönliche Zwecke zu nutzen.
                Die gewerbliche Nutzung für Dritte (z.&nbsp;B. als Bewerbungsagentur) ist ausdrücklich untersagt.
              </p>
              <p className="legal-prose">
                <strong>3.2</strong> Der Nutzer räumt dem Anbieter ein unentgeltliches, einfaches, zeitlich auf
                die Vertragslaufzeit beschränktes Nutzungsrecht an den von ihm hochgeladenen Dokumenten und
                Inhalten ein, soweit dies zur Erbringung der vertraglichen Leistung (insbesondere zur KI-Analyse)
                erforderlich ist.
              </p>
              <p className="legal-prose">
                <strong>3.3</strong> Der Nutzer ist verpflichtet, seine Zugangsdaten sicher aufzubewahren.
              </p>
              <p className="legal-prose">
                <strong>3.4</strong> Bei erheblichen Verstößen gegen diese AGB, geltendes Recht oder bei
                Missbrauch der angebotenen Dienste (z.&nbsp;B. automatisierte Spam-Erstellung) ist der Anbieter
                berechtigt, den Zugang des Nutzers vorübergehend oder dauerhaft zu sperren und den Vertrag
                außerordentlich zu kündigen.
              </p>
            </div>
          </section>

          {/* §4 */}
          <section className="legal-section">
            <h2 className="legal-section__title">4. Pflichten des Nutzers, Inhalte und Haftung für KI</h2>
            <div className="legal-block">
              <p className="legal-prose">
                <strong>4.1</strong> Der Nutzer trägt die alleinige rechtliche Verantwortung für die Richtigkeit,
                Vollständigkeit und Konsequenzen der erstellten Dokumente. Der Nutzer garantiert, dass die von
                ihm hochgeladenen Inhalte keine Rechte Dritter verletzen und frei von Schadsoftware sind.
              </p>
              <p className="legal-prose">
                <strong>4.2</strong> Die eingesetzten KI-Modelle können generativ bedingte Ungenauigkeiten oder
                inhaltliche Abweichungen erzeugen. Der Nutzer ist zwingend verpflichtet, alle durch die KI
                generierten Texte vor dem PDF-Export auf Wahrheit, Korrektheit und die vollständige
                Übereinstimmung mit seinem tatsächlichen Profil zu prüfen.
              </p>
              <p className="legal-prose">
                <strong>4.3</strong> Der Anbieter ist nicht zur Datensicherung bezüglich der vom Nutzer
                generierten oder hochgeladenen Inhalte verpflichtet. Der Nutzer ist selbst für die Speicherung
                seiner finalen Dokumente (z.&nbsp;B. durch lokalen PDF-Download) verantwortlich.
              </p>
            </div>
          </section>

          {/* §5 */}
          <section className="legal-section">
            <h2 className="legal-section__title">5. Externe Daten, Web-Scraping und Freistellung</h2>
            <div className="legal-block">
              <p className="legal-prose">
                <strong>5.1</strong> Die Software ermöglicht den Import von Stellenbeschreibungen per URL. Der
                Nutzer garantiert, dass er diese Funktion nur bei Webseiten anwendet, deren Nutzungsbedingungen
                ein maschinelles Auslesen (Scraping) durch Dritte nicht untersagen.
              </p>
              <p className="legal-prose">
                <strong>5.2</strong> Der Nutzer stellt den Anbieter von sämtlichen Ansprüchen Dritter (inklusive
                angemessener Rechtsverteidigungskosten) frei, die aus einer rechtswidrigen Nutzung der Plattform,
                einer unzulässigen Nutzung der Import-Funktion oder der Verletzung von Rechten Dritter durch
                hochgeladene Inhalte resultieren.
              </p>
            </div>
          </section>

          {/* §6 */}
          <section className="legal-section">
            <h2 className="legal-section__title">6. Vertragslaufzeit, Kündigung und Zahlungsbedingungen</h2>
            <div className="legal-block">
              <p className="legal-prose">
                <strong>6.1</strong> Die angegebenen Preise verstehen sich inklusive der gesetzlichen
                Umsatzsteuer. Das Nutzungsentgelt ist im Voraus fällig.
              </p>
              <p className="legal-prose">
                <strong>6.2</strong> Verträge über kostenpflichtige Pakete werden für die bei der Buchung
                ausdrücklich angegebene Laufzeit geschlossen. Soweit nicht anders in der Produktbeschreibung
                angegeben, verlängert sich der Vertrag automatisch um die ursprüngliche Laufzeit, wenn er nicht
                fristgerecht zum Ende der jeweiligen Laufzeit gekündigt wird. Die Kündigung kann jederzeit über
                die Account-Einstellungen erfolgen.
              </p>
              <p className="legal-prose">
                <strong>6.3</strong> Gekaufte Kontingente (z.&nbsp;B. für Dokumentengenerierungen) verfallen mit
                dem Ende der Vertragslaufzeit und sind nicht auf andere Accounts übertragbar.
              </p>
              <p className="legal-prose">
                <strong>6.4</strong> Befindet sich der Nutzer im Zahlungsverzug, ist der Anbieter berechtigt,
                den Zugang zum System bis zur vollständigen Begleichung der Forderung zu sperren. Rechnungen
                werden ausschließlich in elektronischer Form bereitgestellt.
              </p>
              <p className="legal-prose">
                <strong>6.5</strong> Nach Vertragsende — gleich aus welchem Grund — werden alle personenbezogenen
                Daten des Nutzers (Profildaten, generierte Dokumente, hochgeladene Inhalte) spätestens nach
                30 Tagen unwiderruflich gelöscht, sofern keine gesetzliche Aufbewahrungspflicht einer früheren
                Löschung entgegensteht. Der Nutzer ist verantwortlich, seine Daten vor Vertragsende selbst zu
                exportieren (z.&nbsp;B. per PDF-Download).
              </p>
            </div>
          </section>

          {/* §7 */}
          <section className="legal-section">
            <h2 className="legal-section__title">7. Verfügbarkeit und Gewährleistung</h2>
            <div className="legal-block">
              <p className="legal-prose">
                <strong>7.1</strong> Der Anbieter bemüht sich um eine bestmögliche Verfügbarkeit der Software,
                garantiert jedoch keine 100-prozentige Erreichbarkeit. Wartungsarbeiten oder Ausfälle der
                angebundenen Drittanbieter-APIs können zu temporären Einschränkungen führen.
              </p>
              <p className="legal-prose">
                <strong>7.2</strong> Eine verschuldensunabhängige Haftung auf Schadensersatz für anfängliche
                Mängel der Software wird ausgeschlossen. Die gesetzlichen Gewährleistungsrechte für digitale
                Produkte bleiben unberührt.
              </p>
            </div>
          </section>

          {/* §8 */}
          <section className="legal-section">
            <h2 className="legal-section__title">8. Datenschutz und E-Mail-Werbung</h2>
            <div className="legal-block">
              <p className="legal-prose">
                <strong>8.1</strong> Die Verarbeitung personenbezogener Daten erfolgt nach den Vorgaben der
                DSGVO. Details zur Datenerhebung und Verarbeitung sind in der separaten{' '}
                <Link to="/datenschutz" className="legal-inline-link">Datenschutzerklärung</Link> geregelt.
              </p>
              <p className="legal-prose">
                <strong>8.2</strong> Gemäß § 7 Abs. 3 UWG ist der Anbieter berechtigt, dem Nutzer an die bei
                der Registrierung hinterlegte E-Mail-Adresse Direktwerbung für eigene, ähnliche Waren oder
                Dienstleistungen zuzusenden. Der Nutzer kann dieser Verwendung jederzeit widersprechen
                (z.&nbsp;B. per E-Mail an{' '}
                <a href="mailto:info@cvflow.de" className="legal-inline-link">info@cvflow.de</a>
                {' '}oder über einen Link in der E-Mail), ohne dass hierfür andere als die Übermittlungskosten
                nach den Basistarifen entstehen.
              </p>
            </div>
          </section>

          {/* §9 */}
          <section className="legal-section">
            <h2 className="legal-section__title">9. Haftungsbeschränkung</h2>
            <div className="legal-block">
              <p className="legal-prose">
                <strong>9.1</strong> Der Anbieter haftet unbeschränkt bei Vorsatz und grober Fahrlässigkeit
                sowie bei Schäden aus der Verletzung des Lebens, des Körpers oder der Gesundheit.
              </p>
              <p className="legal-prose">
                <strong>9.2</strong> Bei leichter Fahrlässigkeit haftet der Anbieter nur bei Verletzung einer
                wesentlichen Vertragspflicht (Kardinalpflicht). Die Haftung ist in diesem Fall auf den
                vorhersehbaren, vertragstypischen Schaden begrenzt.
              </p>
            </div>
          </section>

          {/* §10 */}
          <section className="legal-section">
            <h2 className="legal-section__title">10. Schlussbestimmungen</h2>
            <div className="legal-block">
              <p className="legal-prose">
                <strong>10.1</strong> Dieser Vertrag unterliegt dem Recht der Bundesrepublik Deutschland unter
                Ausschluss des UN-Kaufrechts (CISG).
              </p>
              <p className="legal-prose">
                <strong>10.2</strong> Sollten einzelne Bestimmungen dieses Vertrages unwirksam sein, bleiben
                die übrigen Bestimmungen unberührt.
              </p>
              <p className="legal-prose">
                <strong>10.3</strong> Gerichtsstand für alle Streitigkeiten aus diesem Vertragsverhältnis ist
                Elmshorn, sofern der Nutzer Kaufmann, juristische Person des öffentlichen Rechts oder
                öffentlich-rechtliches Sondervermögen ist. Gegenüber Verbrauchern gilt der gesetzliche
                Gerichtsstand.
              </p>
              <p className="legal-prose">
                <strong>10.4</strong> Die Europäische Kommission stellt eine Plattform zur
                Online-Streitbeilegung (OS) bereit:{' '}
                <a
                  href="https://ec.europa.eu/consumers/odr"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="legal-inline-link"
                >
                  https://ec.europa.eu/consumers/odr
                </a>
                . Wir sind nicht verpflichtet und nicht bereit, an einem Streitbeilegungsverfahren vor einer
                Verbraucherschlichtungsstelle teilzunehmen.
              </p>
            </div>
          </section>

          {/* Widerrufsbelehrung */}
          <section className="legal-section">
            <h2 className="legal-section__title">Widerrufsbelehrung für Verbraucher</h2>
            <div className="legal-block">
              <p className="legal-prose" style={{ fontWeight: 600 }}>Widerrufsrecht</p>
              <p className="legal-prose">
                Sie haben das Recht, binnen vierzehn Tagen ohne Angabe von Gründen diesen Vertrag zu
                widerrufen. Die Widerrufsfrist beträgt vierzehn Tage ab dem Tag des Vertragsabschlusses.
              </p>
              <p className="legal-prose">
                Um Ihr Widerrufsrecht auszuüben, müssen Sie uns (Ahmet Furkan Yazgin &amp; Mehmet Yüksel GbR,
                Kaltenweide 182, 25335 Elmshorn, E-Mail:{' '}
                <a href="mailto:info@cvflow.de" className="legal-inline-link">info@cvflow.de</a>)
                {' '}mittels einer eindeutigen Erklärung (z.&nbsp;B. ein mit der Post versandter Brief oder
                E-Mail) über Ihren Entschluss, diesen Vertrag zu widerrufen, informieren. Sie können dafür
                das beigefügte Muster-Widerrufsformular verwenden, das jedoch nicht vorgeschrieben ist.
              </p>
              <p className="legal-prose">
                Zur Wahrung der Widerrufsfrist reicht es aus, dass Sie die Mitteilung über die Ausübung des
                Widerrufsrechts vor Ablauf der Widerrufsfrist absenden.
              </p>

              <p className="legal-prose" style={{ fontWeight: 600, marginTop: 20 }}>Folgen des Widerrufs</p>
              <p className="legal-prose">
                Wenn Sie diesen Vertrag widerrufen, haben wir Ihnen alle Zahlungen, die wir von Ihnen erhalten
                haben, unverzüglich und spätestens binnen vierzehn Tagen ab dem Tag zurückzuzahlen, an dem die
                Mitteilung über Ihren Widerruf dieses Vertrags bei uns eingegangen ist. Für diese Rückzahlung
                verwenden wir dasselbe Zahlungsmittel, das Sie bei der ursprünglichen Transaktion eingesetzt
                haben, es sei denn, mit Ihnen wurde ausdrücklich etwas anderes vereinbart.
              </p>

              <p className="legal-prose" style={{ fontWeight: 600, marginTop: 20 }}>Vorzeitiges Erlöschen des Widerrufsrechts</p>
              <p className="legal-prose">
                Das Widerrufsrecht erlischt bei einem Vertrag über die Lieferung von nicht auf einem
                körperlichen Datenträger befindlichen digitalen Inhalten vorzeitig, wenn wir mit der
                Vertragserfüllung begonnen haben, nachdem Sie ausdrücklich zugestimmt haben, dass wir mit der
                Vertragserfüllung vor Ablauf der Widerrufsfrist beginnen und Sie Ihre Kenntnis davon bestätigt
                haben, dass Sie durch Ihre Zustimmung mit Beginn der Vertragserfüllung Ihr Widerrufsrecht
                verlieren.
              </p>
            </div>
          </section>

          {/* Muster-Widerrufsformular */}
          <section className="legal-section">
            <h2 className="legal-section__title">Muster-Widerrufsformular</h2>
            <div className="legal-block">
              <p className="legal-prose">
                (Wenn Sie den Vertrag widerrufen wollen, füllen Sie bitte dieses Formular aus und senden
                Sie es zurück.)
              </p>
              <div className="legal-form-box">
                <p className="legal-prose"><strong>An:</strong></p>
                <p className="legal-prose">
                  Ahmet Furkan Yazgin &amp; Mehmet Yüksel GbR<br />
                  Kaltenweide 182<br />
                  25335 Elmshorn<br />
                  E-Mail: <a href="mailto:info@cvflow.de" className="legal-inline-link">info@cvflow.de</a>
                </p>
                <p className="legal-prose" style={{ marginTop: 16 }}>
                  Hiermit widerrufe(n) ich/wir (*) den von mir/uns (*) abgeschlossenen Vertrag über die
                  Erbringung der folgenden Dienstleistung: <em>Nutzung von CVFlow</em>
                </p>
                <div className="legal-form-fields">
                  <p className="legal-prose">Bestellt am: <span className="legal-field-line" /></p>
                  <p className="legal-prose">Name des/der Verbraucher(s): <span className="legal-field-line" /></p>
                  <p className="legal-prose">Anschrift des/der Verbraucher(s): <span className="legal-field-line" /></p>
                  <p className="legal-prose">
                    Unterschrift des/der Verbraucher(s) (nur bei Mitteilung auf Papier):
                    <span className="legal-field-line" />
                  </p>
                  <p className="legal-prose">Datum: <span className="legal-field-line" /></p>
                </div>
                <p className="legal-prose" style={{ marginTop: 12, color: 'var(--txt-muted)', fontSize: 13 }}>
                  (*) Unzutreffendes streichen.
                </p>
              </div>
            </div>
          </section>

        </div>

        <div className="legal-footer-nav">
          <Link to="/datenschutz" className="legal-footer-link">Datenschutz →</Link>
          <Link to="/impressum" className="legal-footer-link">Impressum →</Link>
        </div>
      </main>

      <footer className="legal-footer">
        <div className="legal-footer__inner">
          <div className="legal-footer__brand">
            <img src="/logo.png" alt="CVFlow" className="legal-footer__brand-dot" />
          </div>
          <nav className="legal-footer__links">
            <Link to="/impressum">Impressum</Link>
            <Link to="/agb">AGB</Link>
            <Link to="/datenschutz">Datenschutz</Link>
          </nav>
          <div className="legal-footer__status">
            <span className="legal-footer__status-dot" aria-hidden="true" />
            System Online · Made in Germany
          </div>
        </div>
      </footer>
    </div>
  );
}
